import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'does_the_fac_consult_w_wrkrs_andor_prov_a_minimum_notice_period'

export const dataPointDefinition = {
  retracedId: 'does_the_fac_consult_w_wrkrs_andor_prov_a_minimum_notice_period',
  name: 'Does the facility consult with workers and/or provide a minimum notice period for overtime work and/or changes in rest days?',
  description:
    'The intent of this options selection is to understand if the facility consults with workers or notifies them in advance (in other words, ahead of time) about overtime work and/or changes in rest days.\r\r\n\r\r\nAdvance notice period – the minimum period required for notifying workers of changes in their work schedules due to hours averaging. This is essential to allow workers to plan their personal lives and help facilitate work-life balance. A minimum advance notice period of 24 to 48 hours is essential for such scheduling changes. \r\r\n\r\r\nFor example, if the facility does not make any effort to notify workers in advance about overtime work and/or changes in rest days, this option should NOT be selected.',
  meta: {},
  fieldTypeId: 'YES_NO',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wh-ove-3',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 7040,
  sectionId: '2.2.12',
  impactArea: 'Working Hours',
  impactAreaId: 'WORKING_HOURS_AND_OVERTIME',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
